/**
 *将表头和表体数据组装，得到最终显示的数据
 * 1、拿到listdata中的一条数据，遍历表头lines
 */
function handleTableFormat (header, listData) {
  let formatData = []
  if (header.lines && listData.listdata) {
    listData.listdata.forEach((row, index) => {
      let formatRow = []// 一行
      // 一行的一列
      header.lines.forEach((line, k) => {
        formatRow.push(JSON.parse(JSON.stringify(line)))
        formatRow[k].fields = [] // 清空该列原有的显示域
        formatRow[k].fieldsObj = {} // 增加fields对象
        line.fields = handleLines(line) // 将该列的显示域格式化
        // 该列的显示域
        line.fields.forEach((field, i) => {
          let cloneField = JSON.parse(JSON.stringify(field))
          formatRow[k].fields.push(cloneField)
          formatRow[k].fieldsObj[field.code] = cloneField // 将域字段设为key,之后可通过key查找
          /**
           * 每一个组成项有不同的显示方式，目前有三种
           * showtype=0代表直接显示
           * showtype=1代表判断显示
           * showtype=3代表自定义显示
           */
          if (field.showtype === 0 || field.showtype === 2) {
            // 标题图特殊处理,小图不存在则取中图，中图不存在取大图
            if (field.code === 'a_picSmall' && field.image && !row[field.code]) {
              if (row.a_picMiddle) {
                row[field.code] = row.a_picMiddle
              } else if (row.a_picBig) {
                row[field.code] = row.a_picBig
              }
            }

            formatRow[k].fields[i][field.code] = row[field.code]
            formatRow[k].fieldsObj[field.code].fieldVal = row[field.code] // 新增值属性
          } else if (field.showtype === 1) {
            formatRow[k].fields[i].options = []
            formatRow[k].fieldsObj[field.code].options = []
            let arr = handleOptions(field.options, row[field.code], row)
            formatRow[k].fields[i].options.push(arr)
            formatRow[k].fieldsObj[field.code].options.push(arr)
          }
        })
      })
      formatData.push({
        rowOriginal: row, // 每一条的原始数据
        row: formatRow,
        id: row.id,
        index
      })
    })
  }
  return formatData
}

/**
 * 2、lines是所有的列，每一列中包括1-n个组成项-fields，组成想的显示顺序按照fieldspattern字段返回的字段顺序显示
 *
 * 2.1.将显示域规则fieldPattern（比如'[SYS_TOPIC]创建时间:[SYS_CREATED]IP:[a_ip]'）抽成数组["", "[SYS_TOPIC]", "创建时间:", "[SYS_CREATED]", "IP:", "[a_ip]", ""]
 * ——[SYS_CREATED]代表一个显示域，需要根据显示规则显示内容
 * ——"创建时间:"显示域间连接符，直接显示即可
 * 2.2.按照fieldPattern中要显示的域的顺序排列显示域数组fields
 * 2.3.将fieldPattern中数组间的连接符（比如："IP:"）添加到显示域中
 * @param line
 * @returns {Array}
 */
function handleLines (line) {
  let formatLineFields = []
  let fieldPattern = line.fieldspattern || ''
  let linkList = fieldPattern
  let tmp = fieldPattern.replace(/\[/g, '#founder[').replace(/\]/g, ']#founder').split('#founder')
  // 按照fieldspattern中要显示域的顺序组成Array
  tmp.forEach(item => {
    for (let i in line.fields) {
      if (`[${line.fields[i]['code']}]` === item) {
        formatLineFields.push(line.fields[i])
        linkList = linkList.replace(item, '#founder')
        break
      }
    }
  })
  // 域间链接符数组
  linkList = linkList.split('#founder')
  // 添加两个显示域之间的链接符
  formatLineFields.forEach((field, i) => {
    field.patternLink = linkList[i]
     if (field['code'] === 'a_picSmall' && field['image']) {
       field.topicTitleImg = ''
    }
  })
  formatLineFields[formatLineFields.length - 1].patternLinkEnd = linkList[formatLineFields.length]
  return formatLineFields
}

/**
 * 处理选择显示的内容
 *
 * 3.1. 根据 data，找出符合规则的option
 * 3.2. 返回 icon text中任意一个有值的项
 * @param options
 * @param data
 * @returns {string|string|t.default.props.icon|{type, default}|t.default.computed.icon|*}
 */
function handleOptions (options, data, row) {
  if (data !== undefined) {
    let option = options.find((option) => {
      return (option.operator === '=' && '' + option.value === '' + data) ||
        (option.operator === '>' && +data > +option.value) ||
        (option.operator === '<' && +data < +option.value) ||
        (option.operator === '>=' && +data >= +option.value) ||
        (option.operator === '<=' && +data <= +option.value)
    })
    return option || ''
  } else {
    return ''
  }
}

export {
  handleTableFormat
}
